import React, {useEffect, useState, forwardRef, useImperativeHandle} from 'react';
import {useDispatch, useSelector} from "react-redux";
import RevenueStatusSummary from "./RevenueStatusSummary";
import AdfitTermsDialog from "./AdfitTermsDialog";
import RevenueDialog from "../RevenueDialog";
import {addPrefix} from "../../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../../utils/FetchHelper";
import classnames from "classnames";

const IntroContent = ({onClickConnectButton}) => {
  return (
    <>
      <div className="wrap_cont">
        <strong className="screen_out">특징</strong>
        <ul className="list_cont list_cont_type2">
          <li><span className="ico_blog ico_check_type3"/><span
            className="txt_g">빠르고 간편한 심사 및 수익 지급</span></li>
          <li><span className="ico_blog ico_check_type3"/><span className="txt_g">타게팅된 광고로 수익 극대화</span>
          </li>
          <li><span className="ico_blog ico_check_type3"/><span
            className="txt_g">수익 관련 정보 카카오톡 알림 설정 가능</span></li>
        </ul>
      </div>
      <a className="btn_type5" onClick={onClickConnectButton}>연동하기</a>
    </>
  )
};
const ConnectingContent = ({onClickLoginButton}) => {
  const [showDetail, setShowDetail] = useState(false);
  return (
    <>
      <div className="wrap_cont wrap_cont_type2">
        <strong className="screen_out">연동하기 프로세스</strong>
        <ol className="list_revenue_tab">
          <li className="on">연동 안내</li>
          <li>AdFit 로그인</li>
          <li>연동 완료</li>
        </ol>
      </div>
      <div className="box_revenue_plat">
        {showDetail &&
        <AdfitTermsDialog close={() => setShowDetail(false)}/>
        }
        <strong className="screen_out">연동방법</strong>
        <ul className="list_cont_type1">
          <li>
            <span className="num_g">1.</span>
            <span className="txt_g">{'티스토리와 AdFit의 연동 내용을 확인하세요. '}</span>
            <a className="txt_g" onClick={() => setShowDetail(true)}>자세히</a>
          </li>
          <li>
            <span className="num_g">2.</span>
            <span className="txt_g">AdFit을 사용하는 카카오 계정으로 로그인 해주세요.</span>
          </li>
          <li>
            <span className="num_g">3.</span>
            <span className="txt_g">정확한 심사를 위해 데이터 수집용 광고(본문 상단)를 설정합니다.</span>
          </li>
        </ul>
      </div>
      <a className="btn_type6 btn_type6_type1" onClick={onClickLoginButton}>
        <span className="ico_blog ico_kakao"/>카카오 로그인
      </a>
    </>
  )
};
const OngoingContent = ({title, domain}) => {
  return (
    <>
      <div className="wrap_cont wrap_cont_type2">
        <strong className="screen_out">연동하기 프로세스</strong>
        <ol className="list_revenue_tab">
          <li className="on">연동 안내</li>
          <li className="on">AdFit 로그인</li>
          <li className="on">연동 완료</li>
        </ol>
      </div>
      <div className="box_revenue_plat">
        <p className="desc_cont_type1">심사를 진행 중입니다. 심사는 3~5일 소요됩니다.</p>
        <dl className="list_desc">
          <dt>연동블로그</dt>
          <dd className="desc_cont_type1">{title} / {domain}</dd>
        </dl>
      </div>
      <span className="btn_type5 btn_type5_type2">심사 중</span>
    </>
  )
};
const SuspendAndRejectContent = ({message, view, onClickSuspendButton, onClickRejectButton}) => {
  return (
    <>
      <div className="wrap_cont wrap_cont_type2">
        <strong className="screen_out">연동하기 프로세스</strong>
        <ol className="list_revenue_tab">
          <li className="on">연동 안내</li>
          <li className="on">AdFit 로그인</li>
          <li className="on">연동 완료</li>
        </ol>
      </div>
      <div className="box_revenue_plat">
        <p className="desc_cont_type2">
          {view === 'reject' &&
          <em>심사가 반려되었습니다.</em>
          }
          {view === 'suspend' &&
          <em>심사가 보류되었습니다.</em>
          }
          {view === 'ban' &&
          <em>애드핏이 관리자 정지 되었습니다.</em>
          }
          {message}
        </p>
      </div>
      {view === 'suspend' &&
      <a className="btn_type5 btn_type5_type6" onClick={onClickSuspendButton}>심사 보류 / 재심사 요청</a>}
      {view === 'reject' &&
      <a className="btn_type5 btn_type5_type6" onClick={onClickRejectButton}>심사 반려</a>}
    </>
  )
};

const ConnectIssueContent = ({onClickConnectButton}) => {
  const [showLayerPopup, setShowLayerPopup] = useState(false);

  return (
    <>
      <div className="wrap_cont wrap_cont_type2">
        <p className="desc_cont_type2">연동 상태의 재확인이 필요합니다. 연동하기 절차를 다시 진행해 주시기 바랍니다.</p>
      </div>
      <a className="btn_type5" onClick={onClickConnectButton}>연동하기</a>
      <div className="box_revenue_plat">
        <div>
          <dl className="count_revenue">
            <dt className="tit_revenue">노출수
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">클릭수
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">{'eCPM '}
              <div className={classnames('wrap_question', showLayerPopup ? 'open_question' : '')}
                   onMouseEnter={()=>setShowLayerPopup(true)}
                   onMouseLeave={()=>setShowLayerPopup(false)}
              >
                <span className="ico_blog ico_question">설명</span>
                <div className="layer_popup">
                  <div className="inner_popup inner_popup_type3">
                    <p className="desc_g">광고가 1,000회 노출됐을 때 얻을<br/> 수 있는 예상 수익을 말합니다.</p>
                  </div>
                </div>
              </div>
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
          <dl className="count_revenue">
            <dt className="tit_revenue">수익
            </dt>
            <dd className="revenue_cont">
              <span className="txt_bar">-</span>
            </dd>
          </dl>
        </div>
      </div>
    </>
  );
};

const Adfit = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [view, setView] = useState('loading');
  const [suspendDialogInfo, setSuspendDialogInfo] = useState(null);
  const [rejectDialogInfo, setRejectDialogInfo] = useState(null);
  const [requireDialogInfo, setRequireDialogInfo] = useState(null);
  const [accountDialogInfo, setAccountDialogInfo] = useState(null);
  const revenue = useSelector(state => state.revenue);
  const blog = useSelector(state => state.blog);

  const handleClickConnectButton = () => {
    const {blogCreatedDays, entryCount, isKakaoAccount} = revenue.adfitInfo.requirementInfo;
    if (!isKakaoAccount) {
      setAccountDialogInfo({
        title: 'kakaoAdFit 연동 권한 확인',
        content: '블로그와 kakaoAdFit을 연동하기 위해서는 티스토리 계정을 카카오계정으로 전환해야 합니다.',
      });
    } else if (blogCreatedDays < 30 || entryCount < 20) {
      setRequireDialogInfo({
        title: 'kakaoAdFit 연동 권한 확인',
        content: <>애드핏 연동 조건을 확인해 주세요.<br/>블로그 개설일: 30일 이상<br/>3개월 내 발행글: 20개 이상</>,
      });
    } else {
      setView('connecting');
    }
  };
  useImperativeHandle(ref, () => ({
    handleClickConnectButton() {
      const {blogCreatedDays, entryCount, isKakaoAccount} = revenue.adfitInfo.requirementInfo;
      if (!isKakaoAccount) {
        setAccountDialogInfo({
          title: 'kakaoAdFit 연동 권한 확인',
          content: '블로그와 kakaoAdFit을 연동하기 위해서는 티스토리 계정을 카카오 계정으로 전환해야 합니다.',
        });
      } else if (blogCreatedDays < 30 || entryCount < 20) {
        setRequireDialogInfo({
          title: 'kakaoAdFit 연동 권한 확인',
          content: <>애드핏 연동 조건을 확인해 주세요.<br/>블로그 개설일: 30일 이상<br/>3개월 내 발행글: 20개 이상</>,
        });
      } else {
        setView('connecting');
      }
    }
  }));

  const handleClickLoginButton = () => {
    const popupWidth = 1160;
    const popupHeight = 700;
    const popupX = (window.screen.width / 2) - (popupWidth / 2);
    const popupY = (window.screen.height / 2) - (popupHeight / 2);
    window.open(revenue.adfitInfo.url, "_blank", `width=${popupWidth},height=${popupHeight},left=${popupX},top=${popupY}`);
  };

  const handleClickRejectButton = () => {
    setRejectDialogInfo({
      title: 'kakao AdFit 반려 사유',
      content: revenue.adfitInfo.mediaStatusMsg,
    });
  };

  const handleClickSuspendButton = () => {
    setSuspendDialogInfo({
      title: 'kakao AdFit 보류 사유',
      content: revenue.adfitInfo.mediaStatusMsg,
      check: '안내된 사유를 수정했고, 재심사를 요청합니다.',
    });
  };

  const reExamination = () => {
    fetch(addPrefix("/manage/revenue/adfit.json"), {
      method: 'PATCH',
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(() => {
        setSuspendDialogInfo(null);
        window.location.reload();
      })
      .catch(e => {
        alert('재심사 요청 실패');
        setSuspendDialogInfo(null);
      });
  };

  useEffect(() => {
    if (revenue.adfitInfo) {
      if (revenue.adfitInfo.accountCode === 'SUCCESS') {
        if (revenue.adfitInfo.accountResultCode === '090') {
          setView('ban');
        } else {
          if (revenue.adfitInfo.mediaStatusCode === 'PASS') {
            setView('connected');
          } else if (revenue.adfitInfo.mediaStatusCode === 'SUSPEND') {
            setView('suspend');
          } else if (revenue.adfitInfo.mediaStatusCode === 'REJECT') {
            setView('reject');
          } else {
            setView('ongoing');
          }
        }
      } else if (revenue.adfitInfo.accountCode === 'NOT_FOUND_TOKEN') {
        setView('intro');
      } else {
        setView('issue');
      }
    }
  }, [revenue.adfitInfo]);
  return (
    <>
      {suspendDialogInfo &&
      <RevenueDialog
        title={suspendDialogInfo.title}
        content={suspendDialogInfo.content}
        check={suspendDialogInfo.check}
        close={()=>setSuspendDialogInfo(null)}
        confirm={reExamination}
        confirmLabel="재심사 요청"
        cancel={true}
      />
      }
      {rejectDialogInfo &&
      <RevenueDialog
        title={rejectDialogInfo.title}
        content={rejectDialogInfo.content}
        close={()=>setRejectDialogInfo(null)}
        confirm={()=>setRejectDialogInfo(null)}
      />
      }
      {requireDialogInfo &&
      <RevenueDialog
        title={requireDialogInfo.title}
        content={requireDialogInfo.content}
        close={()=>setRequireDialogInfo(null)}
        confirm={()=>setRequireDialogInfo(null)}
      />
      }
      {accountDialogInfo &&
      <RevenueDialog
        title={accountDialogInfo.title}
        content={accountDialogInfo.content}
        close={()=>setAccountDialogInfo(null)}
        cancel={true}
        confirm={()=>{setAccountDialogInfo(null);location.href=`${window.appInfo.topUrl}/account/transfer/start`}}
        confirmLabel='계정전환'
      />
      }
      <div className="box_blog box_blog_type2">
        <div className="wrap_logo">
          <img
            src="//t1.daumcdn.net/tistory_admin/static/manage/images/temp/kakaoadfit.png"
            alt="kakaoAdfit" className="company_logo" width="125"
          />
        </div>
        {view === 'intro' &&
        <IntroContent onClickConnectButton={handleClickConnectButton}/>
        }
        {view === 'connecting' &&
        <ConnectingContent onClickLoginButton={handleClickLoginButton}/>
        }
        {view === 'ongoing' &&
        <OngoingContent title={blog.title} domain={blog.domain}/>
        }
        {(view === 'suspend' || view === 'reject') &&
        <SuspendAndRejectContent
          message={revenue.adfitInfo.mediaStatusMsg}
          view={view}
          onClickRejectButton={handleClickRejectButton}
          onClickSuspendButton={handleClickSuspendButton}
        />
        }
        {view === 'ban' &&
        <SuspendAndRejectContent
          message={revenue.adfitInfo.accountResultCodeMsg}
          view={view}
          onClickRejectButton={handleClickRejectButton}
          onClickSuspendButton={handleClickSuspendButton}
        />
        }
        {view === 'issue' &&
        <ConnectIssueContent
          onClickConnectButton={handleClickConnectButton}
        />
        }
        {view === 'connected' &&
        <RevenueStatusSummary vendor="adfit"/>
      }
    </div>
    </>
  )
});

export default Adfit;